module.exports = __webpack_public_path__ + "static/media/blog.57555fa9.jpg";